import { BrandMark } from "@/components/brand/BrandMark";
import { Button } from "@/components/ui/Button";
import { useAuth } from "@/lib/auth";

/**
 * A thin bar rather than a second header. The page's own title lives in
 * `PageHeader`; this row carries only what is true of the whole session —
 * who is signed in, the theme, and the way out.
 */
export function Topbar({ onOpenNav }: { onOpenNav: () => void }) {
  const { user, signOut, isDevSession } = useAuth();

  return (
    <header className="sticky top-0 z-20 flex h-14 items-center justify-between gap-3 border-b border-white/65 bg-bg/78 px-4 backdrop-blur-xl lg:px-8">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onOpenNav}
          aria-label="Open navigation"
          className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-pink text-ink lg:hidden"
        >
          <span aria-hidden="true" className="text-[17px] leading-none">
            ☰
          </span>
        </button>
        <BrandMark className="h-8 w-8 lg:hidden" />
        <span className="hidden text-[11px] font-bold uppercase tracking-[0.15em] text-muted lg:inline">
          Find Me Matcha / operations
        </span>
      </div>

      <div className="flex items-center gap-2">
        {isDevSession ? (
          // Said out loud, because a console that looks authenticated but is
          // not is the single most dangerous thing this app could pretend.
          <span className="rounded-chip border border-warn/20 bg-warn-soft px-2 py-1 text-[10px] font-bold uppercase tracking-[0.06em] text-warn">
            local dev auth
          </span>
        ) : null}
        <span className="hidden rounded-full bg-white px-3 py-1.5 font-mono text-[10.5px] text-muted shadow-panel sm:inline">
          {user?.email ?? "—"}
        </span>
        <Button variant="ghost" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
